export const quoteswitchConstants = {
    YES : 'YES',
    NO : 'NO'
};